import { Configure } from 'react-instantsearch';

import { useAnalyticsTags } from '@libs/analytics';

import { PRODUCT_LISTING_PAGE_TAG, SEARCH_LANDING_PAGE_TAG } from '@/constants/algoliaTags';
import { getConfigurationFilters, type SubcatFiltering } from '@/utils/category-configuration-filters';

export type ConfigureSearchProps = Readonly<{
    preFilters: string[];
    preFilterLogic: string;
    algoliaCategoryPath: string;
    previewDate: number;
    subcatFiltering?: SubcatFiltering;
}>;

export default function ConfigureSearch({
    preFilters,
    preFilterLogic,
    algoliaCategoryPath,
    previewDate,
    subcatFiltering = {},
}: ConfigureSearchProps) {
    const analyticsTag = [algoliaCategoryPath ? PRODUCT_LISTING_PAGE_TAG : SEARCH_LANDING_PAGE_TAG];
    const tags = useAnalyticsTags(analyticsTag);

    return (
        <Configure
            facetingAfterDistinct
            filters={getConfigurationFilters(
                preFilters,
                preFilterLogic,
                algoliaCategoryPath,
                subcatFiltering,
                previewDate
            )}
            clickAnalytics={true}
            analyticsTags={tags}
        />
    );
}
